<template>
    <div @click="selctCurSubGroup" class="prod_item">
        <div class="img_container">
            <img v-if="image != null && hasImage" :src="image" @error="() => this.hasImage = false">
            <img v-else :src="noImageSrc">
        </div>
        <div class="name_container">
            <div class="container">
                <span class="name" v-text="name"></span>
            </div>
        </div>
    </div>
</template>

<script>

import Util from '@/assets/libs/util'

export default {
    name: 'SubGroupCard',
    props: [
        'name',
        'image',
        'subGroup',
        'subGroupIndex'
    ],
    data () {
        return {
            hasImage: true,
            noImageSrc: null,
            junk: require('../../static/icons/junk-icon.png')
        }
    },
    mounted () {
        this.noImageSrc = Util.getConfigImage('noImage') ? Util.getConfigImage('noImage') : this.junk
    },
    methods: {
        selctCurSubGroup: function () {
            let products = this.subGroup.products
            this.$emit('selectCurGroup', { products, subGroupIndex: this.subGroupIndex })
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import (reference) url("../assets/common.less");

.prod_item {
    position: relative;
    background-color: @white;
    padding: 0;
    text-align: center;
    margin: 10px;
    border: 3px solid @disabled-color;
    border-radius: 25px;
    display: grid;
    grid-template-rows: 200px 80px auto;
    height: -webkit-fill-available;

    .container {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: calc(100% - 30px);
        padding: 0 15px;
    }

    &.slimMode {
        box-shadow: unset;
        grid-template-rows: 150px 50px 40px;
    }
}

.img_container {
    img {
        object-fit: cover;
        width: 100%;
        height: 200px;
        display: block;
        border-top-left-radius: 25px;
        border-top-right-radius: 25px;
    }
}

.name_container {
    position: relative;

    .name {
        font-family: @default-font;
        font-size: 1.3rem;
        display: block;
        max-width: 100%;
        text-transform: uppercase;
        text-align: center;
        margin: auto;
        padding: 0;
    }
}

.price_container {
    position: relative;
    height: 60px;

    .from {
        font-size: 25px;
        color: @black;
        padding-top: 15px;
    }

    .price {
        font-family: @default-font;
        font-size: 25px;
        color: var(--price-font-color);
        margin: 0;
    }

    .bold {
        font-weight: bold;
    }
}

@media (min-width: 699px) and (max-width: 1025px) {

    //@tablet
    .prod_item {
        margin: 10px;
        grid-template-rows: 160px 55px auto;

        .container {
            width: calc(100% - 30px);
            padding: 0 15px;
        }

        &.slimMode {
            box-shadow: unset;
            grid-template-rows: 130px 70px 50px;
        }
    }

    .img_container {
        img {
            height: 160px;
            max-height: unset;
            // margin-top: 10px;
        }
    }

    .name_container {
        .name {
            font-size: 1rem;
        }
    }

    .price_container {
        .from {
            font-size: 1.1rem;
        }

        .price {
            font-size: 1.2rem;
        }
    }

    .description_container {
        padding: 0 5px;
        max-height: 80px;

        .description {
            font-size: 0.9rem;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
        }
    }
}

@media (max-width: 698px) {

    // Gertec SK210
    .prod_item {
        margin: 5px;
        grid-template-rows: 95px 58px auto auto;
        border-width: 1px;
        border-radius: 15px;

        &.slimMode {
            box-shadow: unset;
            grid-template-rows: 130px 70px 50px;
        }
    }

    .img_container {
        img {
            height: 95px;
            // margin-top: 5px;
            border-top-left-radius: 15px;
            border-top-right-radius: 15px;
        }
    }

    .name_container {
        .container {
            .name {
                padding: 5px;
                font-size: 14px;
            }
        }
    }

    .price_container {
        .from {
            font-size: 15px;
        }

        .price {
            font-size: 16px;
        }
    }

    .description_container {
        padding: 0 5px;
        max-height: 80px;

        .description {
            font-size: 13px;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
        }
    }
}

@media (orientation: landscape) {
    .prod_item {
        margin: 10px;
        grid-template-rows: 160px auto;
        border-radius: 12px;
        border: solid 1px rgba(3, 0, 79, 0.4);
        .container {
            width: calc(100% - 30px);
            padding: 0 15px;
        }

        &.slimMode {
            box-shadow: unset;
            grid-template-rows: 130px 70px 50px;
        }
    }

    .img_container {
        img {
            border-top-left-radius: 12px;
            border-top-right-radius: 12px;
            height: 100%;
            // margin-top: 10px;
        }
    }

    .name_container {
        align-self: center;
        height: 100%;
        .name {
            font-size: 1.2rem;
        }
    }

    .description_container {
        padding: 0 5px;
        max-height: 50px;
        min-height: 0;
        .description {
            font-size: 0.9rem;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            line-height: 1.2;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/SubGroupCardGom.vue